import _ from 'lodash';
import { createSelector } from 'reselect';
import timm from 'timm';

import CadminAx          from 'app/actions/company-admin/companies';
import ToastAx           from 'app/actions/toast';
import CadminApi         from 'app/apis/company-admin';
import FormsDuck         from 'app/ducks/company-admin/forms';
import helpers           from 'app/helpers/grant-system';
import Ps                from 'app/helpers/publish-statuses';
import reducerUtils      from 'app/reducers/utils';
import CadminSlx         from 'app/selectors/company-admin/';
import EntitiesSlx       from 'app/selectors/entities';
import RoutingSlx        from 'app/selectors/routing';



const {
  AppStatuses,
} = helpers;


/*
 *  Actions
 */

const Types = {
  LOAD_PAGE_PROGS: 'CA_UI_GRANT_SYS_LOAD_PAGE_PROGS',
  LOAD_PAGE_PROGS_SHOW: 'CA_UI_GRANT_SYS_LOAD_PAGE_PROGS_SHOW',
  LOAD_PAGE_PROGS_EDIT_APP: 'CA_UI_GRANT_SYS_LOAD_PAGE_PROGS_EDIT_APP',
  LOAD_PAGE_PROGS_EDIT_LAND: 'CA_UI_GRANT_SYS_LOAD_PAGE_PROGS_EDIT_LAND',
  LOAD_PAGE_APP: 'CA_UI_GRANT_SYS_LOAD_PAGE_APP',
  LOAD_PAGE_SETTINGS: 'CA_UI_GRANT_SYS_LOAD_PAGE_SETTINGS',
  LOAD_PAGE_WORKFLOW_EDIT: 'CA_UI_GRANT_SYS_LOAD_PAGE_WORKFLOW_EDIT',
  LOAD_PAGE_MY_TASKS: 'CA_UI_GRANT_SYS_LOAD_PAGE_MY_TASKS',
  LOAD_PAGE_BUDGETS: 'CA_UI_GRANT_SYS_LOAD_PAGE_BUDGETS',
  LOAD_PAGE_ASSIGNMENT: 'CA_UI_GRANT_SYS_LOAD_PAGE_ASSIGNMENT',
  PROGRAMS_SEARCH: 'CA_UI_GRANT_SYS_PROGRAMS_SEARCH',
  PROGRAMS_GET: 'CA_UI_GRANT_SYS_PROGRAMS_GET',
  PROGRAMS_CREATE: 'CA_UI_GRANT_SYS_PROGRAMS_CREATE',
  PROGRAMS_UPDATE: 'CA_UI_GRANT_SYS_PROGRAMS_UPDATE',
  PROGRAMS_UPDATE_ADMINS: 'CA_UI_GRANT_SYS_PROGRAMS_UPDATE_ADMINS',
  SET_BLDR_LAND_PROG: 'CA_UI_GRANT_SYS_SET_BLDR_LAND_PROG',
  SET_BLDR_APP_PROG: 'CA_UI_GRANT_SYS_SET_BLDR_APP_PROG',
  APPS_GET: 'CA_UI_GRANT_SYS_APPS_GET',
  APPS_SEARCH: 'CA_UI_GRANT_SYS_APPS_SEARCH',
  APPS_REASSIGN: 'CA_UI_GRANT_SYS_APPS_REASSIGN',
  COMMENTS_SEARCH: 'CA_UI_GRANT_SYS_COMMENTS_SEARCH',
  COMMENTS_CREATE: 'CA_UI_GRANT_SYS_COMMENTS_CREATE',
  COMMENTS_UPDATE: 'CA_UI_GRANT_SYS_COMMENTS_UPDATE',
  COMMENTS_DELETE: 'CA_UI_GRANT_SYS_COMMENTS_DELETE',
  WORKFLOWS_FETCH_TEMPS: 'CA_UI_GRANT_SYS_WORKFLOWS_FETCH_TEMPS',
  WORKFLOWS_GET: 'CA_UI_GRANT_SYS_WORKFLOWS_GET',
  WORKFLOWS_UPDATE: 'CA_UI_GRANT_SYS_WORKFLOWS_UPDATE',
  WORKFLOWS_DELETE: 'CA_UI_GRANT_SYS_WORKFLOWS_DELETE',
  WORKFLOWS_UPDATE_STAGES: 'CA_UI_GRANT_SYS_WORKFLOWS_UPDATE_STAGES',
  TASKS_CREATE: 'CA_UI_GRANT_SYS_TASKS_CREATE',
  TASKS_UPDATE: 'CA_UI_GRANT_SYS_TASKS_UPDATE',
  TASKS_DELETE: 'CA_UI_GRANT_SYS_TASKS_DELETE',
  ASSIGNS_CREATE_MANY: 'CA_UI_GRANT_SYS_ASSIGNS_CREATE_MANY',
  ASSIGNS_DELETE: 'CA_UI_GRANT_SYS_ASSIGNS_DELETE',
  MY_ASSIGNS_SEARCH: 'CA_UI_GRANT_SYS_MY_ASSIGNS_SEARCH',
  MY_ASSIGNS_GET: 'CA_UI_GRANT_SYS_MY_ASSIGNS_GET',
  MY_ASSIGNS_COMPLETE: 'CA_UI_GRANT_SYS_MY_ASSIGNS_COMPLETE',
  MY_ASSIGNS_POOL_TASKS_SEARCH: 'CA_UI_GRANT_SYS_MY_ASSIGNS_POOL_TASKS_SEARCH',
  EMAILS_SEARCH: 'CA_UI_GRANT_SYS_EMAILS_SEARCH',
  EMAILS_GET: 'CA_UI_GRANT_SYS_EMAILS_GET',
  EMAILS_CREATE: 'CA_UI_GRANT_SYS_EMAILS_CREATE',
  EMAILS_UPDATE: 'CA_UI_GRANT_SYS_EMAILS_UPDATE',
  EMAILS_DELETE: 'CA_UI_GRANT_SYS_EMAILS_DELETE',
  LOAD_APP_COUNTS: 'CA_UI_GRANT_SYS_LOAD_APP_COUNTS',
};

const Ax = {

  loadPagePrograms: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.programsSearch(params.companySlug)),
      dispatch(Ax.appsSearch(params.companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_PROGS, promise});
  },

  loadPageProgramsShow: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.programsGet(params.companySlug, params.grantProgramId)),
      dispatch(Ax.appsSearch(params.companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_PROGS_SHOW, promise});
  },

  loadPageProgramsEditApp: ({params}) => (dispatch, getState) => {
    dispatch(Ax.setBuilderAppProgram(null));
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.programsGet(params.companySlug, params.grantProgramId)).then(({grantProgram}) => {
        dispatch(Ax.setBuilderAppProgram(grantProgram));
      }),
      dispatch(FormsDuck.Ax.loadAll(params.companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_PROGS_EDIT_APP, promise});
  },

  loadPageProgramsEditLanding: ({params}) => (dispatch, getState) => {
    dispatch(Ax.setBuilderLandingPageProgram(null));
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.programsGet(params.companySlug, params.grantProgramId)),
    ]).then(([_foo, {grantProgram}]) => {
      dispatch(Ax.setBuilderLandingPageProgram(grantProgram));
    });
    return dispatch({type: Types.LOAD_PAGE_PROGS_EDIT_LAND, promise});
  },

  loadPageApp: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.appsGet(params.companySlug, params.grantAppId)),
      dispatch(Ax.commentsSearch(params.companySlug, params.grantAppId)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_APP, promise});
  },

  loadPageSettings: ({params, query}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.workflowsFetchTemplates(params.companySlug)),
      dispatch(FormsDuck.Ax.loadAll(params.companySlug)),
      dispatch(Ax.programsSearch(params.companySlug)),
      dispatch(Ax.emailsSearch(params.companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_SETTINGS, promise});
  },

  loadPageWorkflowEdit: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.workflowsGet(params.companySlug, params.grantWorkflowId)),
      dispatch(Ax.loadAppCounts(params.companySlug, params.grantWorkflowId)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_WORKFLOW_EDIT, promise});
  },

  loadPageMyTasks: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.myAssignmentsSearch(params.companySlug)),
      ...((params.tab === 'pool') ? [
        dispatch(Ax.myAssignmentsPoolTasksSearch(params.companySlug)),
      ] : []),
    ]);
    return dispatch({type: Types.LOAD_PAGE_MY_TASKS, promise});
  },

  loadPageBudgets: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.programsSearch(params.companySlug)),
      dispatch(Ax.appsSearch(params.companySlug)),
    ]);
    return dispatch({type: Types.LOAD_PAGE_BUDGETS, promise});
  },

  loadPageAssignment: ({params}) => (dispatch, getState) => {
    const promise = Promise.all([
      dispatch(CadminAx.loadCommon(params.companySlug)),
      dispatch(Ax.myAssignmentsGet(params.companySlug, params.grantAssignmentId))
    ]);
    return dispatch({type: Types.LOAD_PAGE_ASSIGNMENT, promise});
  },

  programsSearch: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantProgramsSearch(companyId);
    return dispatch({type: Types.PROGRAMS_SEARCH, promise, _entities: ['grantPrograms', 'grantCattrSet']});
  },

  programsGet: (companyId, programId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantProgramsGet(companyId, programId);
    return dispatch({type: Types.PROGRAMS_GET, promise, _entities: ['grantProgram', 'grantWorkflow', 'forms', 'employees', 'grantCattrSet']});
  },

  programsCreate: (companyId, attrs) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantProgramsCreate(companyId, attrs);
    return dispatch({type: Types.PROGRAMS_CREATE, promise, _entities: ['grantProgram', 'grantWorkflow', 'forms', 'employees']});
  },

  programsUpdate: (companyId, programId, attrs) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantProgramsUpdate(companyId, programId, attrs);
    return dispatch({type: Types.PROGRAMS_UPDATE, promise, _entities: ['grantProgram', 'grantWorkflow', 'forms', 'employees']});
  },

  programsUpdateAdmins: (companyId, programId, adminIds) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantProgramsUpdateAdmins(companyId, programId, adminIds);
    return dispatch({type: Types.PROGRAMS_UPDATE_ADMINS, promise,  _entities: ['grantProgram', 'grantWorkflow', 'forms', 'employees']});
  },

  setBuilderLandingPageProgram: (keyVals) => {
    return {type: Types.SET_BLDR_LAND_PROG, keyVals};
  },

  setBuilderAppProgram: (keyVals) => {
    return {type: Types.SET_BLDR_APP_PROG, keyVals};
  },

  appsGet: (companyId, appId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAppsGet(companyId, appId);
    return dispatch({type: Types.APPS_GET, promise, _entities: ['grantProgram', 'grantApp', 'forms', 'grantWorkflow', 'grantAssignments', 'employees']});
  },

  appsSearch: (companyId, params={}) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAppsSearch(companyId, params);
    return dispatch({type: Types.APPS_SEARCH, promise, _entities: ['grantPrograms', 'grantApps']});
  },

  appsReassign: (appId, programId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAppsReassign(companyId, appId, programId);
    promise.then(() => {
      dispatch(CadminAx.getAttentionNumbers(companyId, {refresh: true}));
    });
    return dispatch({type: Types.APPS_REASSIGN, promise, _entities: ['grantProgram', 'grantApp', 'forms', 'grantWorkflow', 'grantAssignments', 'employees']});
  },

  commentsSearch: (companyId, appId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAppCommentsSearch(companyId, appId);
    return dispatch({type: Types.COMMENTS_SEARCH, promise, _entities: ['grantAppComments', 'grantApp', 'employees']});
  },

  commentsCreate: (appId, attrs) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAppCommentsCreate(companyId, appId, attrs);
    promise.then(() => {
      dispatch(Ax.commentsSearch(companyId, appId));
    });
    return dispatch({type: Types.COMMENTS_CREATE, promise, _entities: ['grantAppComment', 'employees']});
  },

  commentsUpdate: (appId, commentId, attrs) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAppCommentsUpdate(companyId, appId, commentId, attrs);
    promise.then(() => {
      dispatch(Ax.commentsSearch(companyId, appId));
    });
    return dispatch({type: Types.COMMENTS_UPDATE, promise, _entities: ['grantAppComment', 'employees']});
  },

  commentsDelete: (appId, commentId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAppCommentsDelete(companyId, appId, commentId);
    promise.then(() => {
      dispatch(Ax.commentsSearch(companyId, appId));
    });
    return dispatch({type: Types.COMMENTS_DELETE, promise});
  },

  workflowsFetchTemplates: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantWorkflowsFetchTemplates(companyId);
    return dispatch({type: Types.WORKFLOWS_FETCH_TEMPS, promise, _entities: ['grantWorkflows', 'employees']});
  },

  workflowsGet: (companyId, workflowId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantWorkflowsGet(companyId, workflowId);
    return dispatch({type: Types.WORKFLOWS_GET, promise, _entities: ['grantWorkflow', 'employees']});
  },

  workflowsUpdate: (companyId, workflowId, attrs) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantWorkflowsUpdate(companyId, workflowId, attrs);
    return dispatch({type: Types.WORKFLOWS_UPDATE, promise, _entities: ['grantWorkflow', 'employees']});
  },

  workflowsDelete: (companyId, workflowId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantWorkflowsDelete(companyId, workflowId);
    return dispatch({type: Types.WORKFLOWS_DELETE, promise});
  },

  workflowsUpdateStages: (companyId, workflowId, {stages, deleteIds}) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantWorkflowsUpdateStages(companyId, workflowId, {stages, deleteIds});
    return dispatch({type: Types.WORKFLOWS_UPDATE_STAGES, promise, _entities: ['grantWorkflow', 'employees']});
  },

  tasksCreate: (workflowId, attrs) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantTasksCreate(companyId, workflowId, attrs);
    return dispatch({type: Types.TASKS_CREATE, promise, _entities: ['grantWorkflow', 'employees']});
  },

  tasksUpdate: (workflowId, taskId, attrs) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantTasksUpdate(companyId, workflowId, taskId, attrs);
    return dispatch({type: Types.TASKS_UPDATE, promise, _entities: ['grantWorkflow', 'employees']});
  },

  tasksDelete: (workflowId, taskId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantTasksDelete(companyId, workflowId, taskId);
    return dispatch({type: Types.TASKS_DELETE, promise, _entities: ['grantWorkflow', 'employees']});
  },

  assignmentsCreateMany: (appId, {taskId, employeeIds}) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAssignmentsCreateMany(companyId, appId, {taskId, employeeIds});
    promise.then(() => {
      dispatch(CadminAx.getAttentionNumbers(companyId, {refresh: true}));
    });
    return dispatch({type: Types.ASSIGNS_CREATE_MANY, promise, _entities: ['grantProgram', 'grantApp', 'forms', 'grantWorkflow', 'grantAssignments', 'employees']});
  },

  assignmentsDelete: (assId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantAssignmentsDelete(companyId, assId);
    promise.then(() => {
      dispatch(CadminAx.getAttentionNumbers(companyId, {refresh: true}));
    });
    return dispatch({type: Types.ASSIGNS_DELETE, promise, _entities: ['grantProgram', 'grantApp', 'forms', 'grantWorkflow', 'grantAssignments', 'employees']});
  },

  myAssignmentsSearch: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantMyAssignmentsSearch(companyId);
    return dispatch({type: Types.MY_ASSIGNS_SEARCH, promise, _entities: ['grantPrograms', 'grantApps', 'grantWorkflows', 'grantAssignments']});
  },

  myAssignmentsGet: (companyId, assId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantMyAssignmentsGet(companyId, assId);
    return dispatch({type: Types.MY_ASSIGNS_GET, promise, _entities: ['grantProgram', 'grantApp', 'forms', 'grantWorkflow', 'grantAssignments', 'employees']});
  },

  myAssignmentsComplete: (assId, params) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantMyAssignmentsComplete(companyId, assId, params);
    promise.then(() => {
      dispatch(CadminAx.getAttentionNumbers(companyId, {refresh: true}));
    });
    return dispatch({type: Types.MY_ASSIGNS_COMPLETE, promise, _entities: ['grantProgram', 'grantApp', 'forms', 'grantWorkflow', 'grantAssignments', 'employees']});
  },

  myAssignmentsPoolTasksSearch: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantMyAssignmentsPoolTasksSearch(companyId);
    return dispatch({type: Types.MY_ASSIGNS_POOL_TASKS_SEARCH, promise});
  },

  emailsUpdate: (companyId, emailId, attrs) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantEmailsUpdate(companyId, emailId, attrs);
    promise.then(() => {
      dispatch(ToastAx.success('Email template updated.'));
    });
    return dispatch({type: Types.EMAILS_UPDATE, promise, _entities: ['grantEmail']});
  },

  emailsSearch: (companyId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantEmailsSearch(companyId);
    return dispatch({type: Types.EMAILS_SEARCH, promise, _entities: ['grantEmails']});
  },

  emailsGet: (companyId, emailId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantEmailsGet(companyId, emailId);
    return dispatch({type: Types.EMAILS_GET, promise, _entities: ['grantEmail']});
  },

  emailsDelete: (companyId, emailId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantEmailsDelete(companyId, emailId);
    promise.then(() => {
      dispatch(Ax.emailsSearch(companyId));
      dispatch(ToastAx.success('Email template deleted.'));
    });
    return dispatch({type: Types.EMAILS_DELETE, promise});
  },

  emailsCreate: (companyId, attrs) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.grantEmailsCreate(companyId, attrs);
    promise.then(() => {
      dispatch(Ax.emailsSearch(companyId));
      dispatch(ToastAx.success('Email template created.'));
    });
    return dispatch({type: Types.EMAILS_CREATE, promise, _entities: ['grantEmail']});
  },

  loadAppCounts: (companyId, grantWorkflowId) => (dispatch, getState) => {
    const state = getState();
    const appCounts = Slx.appCounts(state);
    const hasLoaded = _.isFinite(appCounts[grantWorkflowId]);
    if (hasLoaded) return;
    if (!companyId) companyId = CadminSlx.companyId(state);
    const promise = CadminApi.grantAppsCount(companyId, {grantWorkflowId});
    return dispatch({type: Types.LOAD_APP_COUNTS, promise});
  },

};



/*
 *  Reducer
 */

const initialState = {
  bldrAppProg: null,
  bldrLandProg: null,
  workflowIds: null,
  programIds: null,
  appIds: null,
  workflowCreatePending: false,
  taskUpdatePending: false,
  assCompletePending: false,
  myAssIds: null,
  appReassignPending: false,
  poolTasks: null,
  emailIds: null,
  appCounts: {},
  wfUpdatePending: false,
  wfDeletePending: false,
  progUpdateAdminsPending: false,
};

const reducer = reducerUtils.createReducer(initialState, {

  [Types.SET_BLDR_LAND_PROG]: (state, {keyVals}) => {
    if (keyVals == null) return {...state, bldrLandProg: null};
    const prevProg = state.bldrLandProg || {};
    const newProg = {...prevProg, ...keyVals};
    return {...state,
      bldrLandProg: newProg,
    };
  },

  [Types.SET_BLDR_APP_PROG]: (state, {keyVals}) => {
    if (keyVals == null) return {...state, bldrAppProg: null};
    const prevProg = state.bldrAppProg || {};
    const newProg = {...prevProg, ...keyVals};
    return {...state,
      bldrAppProg: newProg,
    };
  },

  [`${Types.WORKFLOWS_FETCH_TEMPS}_PENDING`]: (state, action) => {
    return {...state, workflowIds: null};
  },
  [`${Types.WORKFLOWS_FETCH_TEMPS}_RESOLVED`]: (state, action) => {
    const workflowIds = action.result.grantWorkflows.map(gw => gw.id);
    return {...state, workflowIds};
  },

  [`${Types.APPS_SEARCH}_PENDING`]: (state, action) => {
    return {...state, appIds: null};
  },
  [`${Types.APPS_SEARCH}_RESOLVED`]: (state, action) => {
    const appIds = action.result.grantApps.map(ga => ga.id);
    return {...state, appIds};
  },

  [`${Types.WORKFLOWS_UPDATE}_PENDING`]: (state, action) => {
    return {...state, wfUpdatePending: true};
  },
  [`${Types.WORKFLOWS_UPDATE}_RESOLVED`]: (state, action) => {
    return {...state, wfUpdatePending: false};
  },
  [`${Types.WORKFLOWS_UPDATE}_REJECTED`]: (state, action) => {
    return {...state, wfUpdatePending: false};
  },

  [`${Types.WORKFLOWS_DELETE}_PENDING`]: (state, action) => {
    return {...state, wfDeletePending: true};
  },
  [`${Types.WORKFLOWS_DELETE}_RESOLVED`]: (state, action) => {
    return {...state, wfDeletePending: false};
  },
  [`${Types.WORKFLOWS_DELETE}_REJECTED`]: (state, action) => {
    return {...state, wfDeletePending: false};
  },

  [`${Types.TASKS_UPDATE}_PENDING`]: (state, action) => {
    return {...state, taskUpdatePending: true};
  },
  [`${Types.TASKS_UPDATE}_RESOLVED`]: (state, action) => {
    return {...state, taskUpdatePending: false};
  },
  [`${Types.TASKS_UPDATE}_REJECTED`]: (state, action) => {
    return {...state, taskUpdatePending: false};
  },

  [`${Types.APPS_REASSIGN}_PENDING`]: (state, action) => {
    return {...state, appReassignPending: true};
  },
  [`${Types.APPS_REASSIGN}_RESOLVED`]: (state, action) => {
    return {...state, appReassignPending: false};
  },
  [`${Types.APPS_REASSIGN}_REJECTED`]: (state, action) => {
    return {...state, appReassignPending: false};
  },

  [`${Types.MY_ASSIGNS_POOL_TASKS_SEARCH}_PENDING`]: (state, action) => {
    return {...state, poolTasks: null};
  },
  [`${Types.MY_ASSIGNS_POOL_TASKS_SEARCH}_RESOLVED`]: (state, action) => {
    return {...state, poolTasks: action.result.poolTasks};
  },

  [`${Types.PROGRAMS_SEARCH}_PENDING`]: (state, action) => {
    return {...state, programIds: null};
  },
  [`${Types.PROGRAMS_SEARCH}_RESOLVED`]: (state, action) => {
    const programIds = action.result.grantPrograms.map(gp => gp.id);
    return {...state, programIds};
  },

  [`${Types.MY_ASSIGNS_COMPLETE}_PENDING`]: (state, action) => {
    return {...state, assCompletePending: true};
  },
  [`${Types.MY_ASSIGNS_COMPLETE}_RESOLVED`]: (state, action) => {
    return {...state, assCompletePending: false};
  },
  [`${Types.MY_ASSIGNS_COMPLETE}_REJECTED`]: (state, action) => {
    return {...state, assCompletePending: false};
  },

  [`${Types.PROGRAMS_UPDATE_ADMINS}_PENDING`]: (state, action) => {
    return {...state, progUpdateAdminsPending: true};
  },
  [`${Types.PROGRAMS_UPDATE_ADMINS}_RESOLVED`]: (state, action) => {
    return {...state, progUpdateAdminsPending: false};
  },
  [`${Types.PROGRAMS_UPDATE_ADMINS}_REJECTED`]: (state, action) => {
    return {...state, progUpdateAdminsPending: false};
  },

  [`${Types.MY_ASSIGNS_SEARCH}_PENDING`]: (state, action) => {
    return {...state, myAssIds: null};
  },
  [`${Types.MY_ASSIGNS_SEARCH}_RESOLVED`]: (state, action) => {
    return {...state, myAssIds: action.result.grantAssignments.map(ass => ass.id)};
  },

  [`${Types.EMAILS_SEARCH}_PENDING`]: (state, action) => {
    return {...state, emailIds: null};
  },
  [`${Types.EMAILS_SEARCH}_RESOLVED`]: (state, action) => {
    return {...state, emailIds: action.result.grantEmails.map(ge => ge.id)};
  },

  [`${Types.LOAD_APP_COUNTS}_RESOLVED`]: (state, action) => {
    return {...state,
      appCounts: {...state.appCounts,
        ...(action.result || {}),
      },
    };
  },

});



/*
 *  Selectors
 */

const Slx = (() => {

  const selBldrLandProg            = (state) => state.companyAdmin.grantSystem.bldrLandProg;
  const selBldrAppProg             = (state) => state.companyAdmin.grantSystem.bldrAppProg;
  const selWorkflowIds             = (state) => state.companyAdmin.grantSystem.workflowIds;
  const selProgramIds              = (state) => state.companyAdmin.grantSystem.programIds;
  const selAppIds                  = (state) => state.companyAdmin.grantSystem.appIds;
  const selWorkflowCreatePending   = (state) => state.companyAdmin.grantSystem.workflowCreatePending;
  const selTaskUpdatePending       = (state) => state.companyAdmin.grantSystem.taskUpdatePending;
  const selAssCompletePending      = (state) => state.companyAdmin.grantSystem.assCompletePending;
  const selMyAssIds                = (state) => state.companyAdmin.grantSystem.myAssIds;
  const selEmailIds                = (state) => state.companyAdmin.grantSystem.emailIds;
  const selAppReassignPending      = (state) => state.companyAdmin.grantSystem.appReassignPending;
  const selPoolTasks               = (state) => state.companyAdmin.grantSystem.poolTasks;
  const selAppCounts               = (state) => state.companyAdmin.grantSystem.appCounts;
  const selWfUpdatePending         = (state) => state.companyAdmin.grantSystem.wfUpdatePending;
  const selWfDeletePending         = (state) => state.companyAdmin.grantSystem.wfDeletePending;
  const selProgUpdateAdminsPending = (state) => state.companyAdmin.grantSystem.progUpdateAdminsPending;

  const selApp = (state, app) => app;
  const selId = (state, id) => id;

  const selAllApps = createSelector(
    [selAppIds, EntitiesSlx.grantApps],
    (ids, gaMap) => {
      if (!ids) return null;
      return ids.map(id => gaMap[id]).filter(ga => ga);
    }
  );

  const selAllEmails = createSelector(
    [selEmailIds, EntitiesSlx.grantEmails],
    (ids, geMap) => {
      if (!ids) return null;
      return ids.map(id => geMap[id]).filter(ga => ga);
    }
  );

  const selPathProgram = createSelector(
    [RoutingSlx.params, EntitiesSlx.grantPrograms],
    (params, gpMap) => {
      return gpMap[params.grantProgramId] || null;
    }
  );
  const selPathProgramApps = createSelector(
    [selPathProgram, selAllApps],
    (program, apps) => {
      if (!program || !apps) return [];
      return apps.filter(app => app.grantProgramId === program.id);
    }
  );

  const selPathWorkflow = createSelector(
    [RoutingSlx.params, EntitiesSlx.grantWorkflows],
    (params, gwMap) => {
      return gwMap[params.grantWorkflowId] || null;
    }
  );

  const selPathApp = createSelector(
    [RoutingSlx.params, EntitiesSlx.grantApps],
    (params, gaMap) => {
      return gaMap[params.grantAppId] || null;
    }
  );

  const appToProgram = (app, gpMap) => gpMap[app?.grantProgramId] || null;
  const selPathAppProgram = createSelector(
    [selPathApp, EntitiesSlx.grantPrograms],
    appToProgram
  );
  const selAppProgram = createSelector(
    [selApp, EntitiesSlx.grantPrograms],
    appToProgram
  );

  const appToWorkflow = (app, gwMap) => gwMap[app?.grantWorkflowId] || null;
  const selPathAppWorkflow = createSelector(
    [selPathApp, EntitiesSlx.grantWorkflows],
    appToWorkflow
  );
  const selAppWorkflow = createSelector(
    [selApp, EntitiesSlx.grantWorkflows],
    appToWorkflow
  );

  const appToAssignments = (app, gassMap, empMap, comMap) => {
    const ids = app?.grantAssignmentIds;
    if (!ids) return null;
    return ids.map(id => gassMap[id]).filter(ass => ass).map((ass) => {
      const employee = empMap[ass.employeeId];
      const mainComment = comMap[ass.mainCommentId];
      if (!employee) return ass;
      return {...ass, employee, mainComment};
    });
  };
  const selPathAppAssignments = createSelector(
    [selPathApp, EntitiesSlx.grantAssignments, EntitiesSlx.employees, EntitiesSlx.grantAppComments],
    appToAssignments
  );
  const selAppAssignments = createSelector(
    [selApp, EntitiesSlx.grantAssignments, EntitiesSlx.employees, EntitiesSlx.grantAppComments],
    appToAssignments
  );

  const appToAnswerMap = (app) => {
    if (!app) return null;
    const map = {};
    (app.formSubmissions || []).forEach((fsub) => {
      (fsub.formAnswers || []).forEach((fans) => {
        map[fans.id] = fans;
      });
    });
    return map;
  };
  const selAppAnswerMap = createSelector(
    [selApp],
    appToAnswerMap
  );
  const selPathAppAnswerMap = createSelector(
    [selPathApp],
    appToAnswerMap
  );

  const appToComments = (app, ansMap, gcMap, empMap) => {
    const ids = app?.grantAppCommentIds;
    if (!ids) return null;
    return ids.map(id => gcMap[id]).filter(c => c).map((comment) => {
      return {
        ...comment,
        employee: empMap[comment.employeeId] || null,
        formAnswer: ansMap[comment.formAnswerId] || null,
      };
    });
  };
  const selAppComments = createSelector(
    [selApp, selAppAnswerMap, EntitiesSlx.grantAppComments, EntitiesSlx.employees],
    appToComments
  );
  const selPathAppComments = createSelector(
    [selPathApp, selPathAppAnswerMap, EntitiesSlx.grantAppComments, EntitiesSlx.employees],
    appToComments
  );

  const commentsToMap = (comments) => {
    if (!comments) return {};
    const map = {};
    comments.forEach((comment) => {
      ['formAnswerId', 'grantAssignmentId'].forEach((attr) => {
        const id = comment[attr];
        if (!id) return;
        if (!map[id]) map[id] = [];
        map[id].push(comment);
      });
    });
    return map;
  };
  const selPathAppCommentMap = createSelector(
    [selPathAppComments],
    commentsToMap
  );
  const selAppCommentMap = createSelector(
    [selAppComments],
    commentsToMap
  );

  // chronological feed of everything that has happened on the grant app
  const selAppTimeline = createSelector(
    [selApp, selAppWorkflow, selAppAssignments, selAppComments],
    (app, workflow, assignments, comments) => {
      if (!app) return null;

      const TT = helpers.TimelineTypes; 
      const stagesById = {};
      const tasksById = {};
      (workflow?.stages || []).forEach((stage) => {
        stagesById[stage.id] = stage;
        (stage.tasks || []).forEach((task) => { tasksById[task.id] = task; });
      });

      const events = [];
      const addEvent = (key, type, ts, by, data={}) => {
        if (!_.isFinite(ts)) throw new Error('tried to add event to timeline without a timestamp');
        events.push({key, type, ts, by, app, ...data});
      };

      // app submitted
      if (app.submittedTs) {
        addEvent(app.id, TT.SUBMITTED, app.submittedTs, null, {app});
      }

      // comments
      (comments || []).forEach((comment) => {
        const type = comment.files?.length ? TT.ATTACHMENT : TT.COMMENT;
        addEvent(comment.id, type, comment.createdTs, comment.employee, {comment});
      });

      // assignment created / submitted
      (assignments || []).forEach((ass) => {
        const task = tasksById[ass.grantTaskId] || null;
        const stage = stagesById[ass.grantStageId] || null;
        if (ass.assignedTs) {
          addEvent(ass.id, TT.ASSIGNMENT, ass.assignedTs, null, {task, stage, ass});
        }
        if (ass.completedTs) {
          addEvent(ass.id, TT.TASK_RESULT, ass.completedTs, ass.employee, {task, stage, ass});
        }
      });

      // app moved to stage
      (app.stageAssignments || []).forEach((sa, idx) => {
        addEvent(sa.stageId, TT.NEW_STAGE, sa.timestamp, null, {stage: stagesById[sa.stageId]});
      });

      return _.sortBy(events, (ev) => ev.ts || 0);
    }
  );

  const selPathAss = createSelector(
    [RoutingSlx.params, EntitiesSlx.grantAssignments, EntitiesSlx.employees, EntitiesSlx.grantAppComments],
    (params, assMap, empMap, comMap) => {
      const ass = assMap[params.grantAssignmentId] || null;
      if (!ass) return null;
      return {
        ...ass,
        employee: empMap[ass.employeeId] || null,
        mainComment: comMap[ass.mainCommentId] || null,
      };
    }
  );
  const selPathAssProgram = createSelector(
    [selPathAss, EntitiesSlx.grantPrograms],
    (ass, pMap) => (pMap[ass?.grantProgramId] || null)
  );
  const selPathAssApp = createSelector(
    [selPathAss, EntitiesSlx.grantApps],
    (ass, aMap) => (aMap[ass?.grantAppId] || null)
  );
  const selPathAssWorkflow = createSelector(
    [selPathAss, EntitiesSlx.grantWorkflows],
    (ass, wfMap) => (wfMap[ass?.grantWorkflowId] || null)
  );

  const selAllPrograms = createSelector(
    [selProgramIds, EntitiesSlx.grantPrograms],
    (ids, gpMap) => {
      if (!ids) return null;
      return ids.map(id => gpMap[id]);
    }
  );

  const selAllWorkflows = createSelector(
    [selWorkflowIds, EntitiesSlx.grantWorkflows],
    (ids, gwMap) => {
      if (!ids) return null;
      return ids.map(id => gwMap[id]);
    }
  );

  const selTemplateWorkflows = createSelector(
    [CadminSlx.companyId, selAllWorkflows],
    (companyId, workflows) => {
      if (!workflows) return null;
      return workflows.filter(gw => !gw.grantProgramId && (gw.companyId === companyId));
    }
  );

  const selMyAssignments = createSelector(
    [selMyAssIds, EntitiesSlx.grantAssignments, EntitiesSlx.grantApps, EntitiesSlx.grantWorkflows, EntitiesSlx.grantPrograms],
    (ids, assMap, appMap, wfMap, proMap) => {
      if (!ids) return null;
      return ids.map((id) => {
        const ass = assMap[id];
        if (!ass) return null;
        const workflow = wfMap[ass.grantWorkflowId];
        const app = appMap[ass.grantAppId];
        const program = proMap[ass.grantProgramId];
        if (!workflow || !app || !program) return null;
        let task;
        const stage = (workflow.stages || []).find((stage) => {
          return stage.tasks.find((t) => {
            if (t.id === ass.grantTaskId) {
              task = t;
              return true;
            }
            return false;
          });
        });
        return {ass, app, program, stage, task};
      }).filter(a => a);
    }
  );

  const selMyAssignmentsTodo = createSelector(
    [selMyAssignments],
    (assigns) => {
      if (!assigns) return null;
      return assigns.filter(ass => !ass.ass.completedTs);
    }
  );

  const selMyAssignmentsDone = createSelector(
    [selMyAssignments],
    (assigns) => {
      if (!assigns) return null;
      return assigns.filter(ass => !!ass.ass.completedTs);
    }
  );

  const selCattrs = createSelector(
    [CadminSlx.companyId, EntitiesSlx.grantCattrSets],
    (id, csMap) => {
      const attrs = [...(csMap[id]?.cattrs || [])];
      return attrs.map((attr) => {
        return {
          id: attr.id,
          label: attr.name,
          options: attr.options.map((opt) => {
            return {
              id: opt.id,
              value: opt.id, // makes it work with StandardSelect
              label: opt.name,
            }
          }),
        };
      });
    }
  );

  const baseProgramStats = {
    pendingAppCount: 0,
    approvedAppCount: 0,
    declinedAppCount: 0,
    requestedAmount: 0,
    awardedAmount: 0,
  };
  const selProgramStats = createSelector(
    [selAllApps],
    (apps) => {
      if (!apps) return {};
      const map = {default: {...baseProgramStats}};
      apps.forEach((app) => {
        if (app.status === AppStatuses.DRAFT) return;
        if (!map[app.grantProgramId]) map[app.grantProgramId] = {...baseProgramStats};
        const stats = map[app.grantProgramId];
        if (app.status === AppStatuses.REVIEW) {
          stats.pendingAppCount += 1;
          stats.requestedAmount += (app.amountRequested || 0);
        } else if (app.status === AppStatuses.APPROVED) {
          stats.approvedAppCount += 1;
          stats.awardedAmount += (app.amountAwarded || 0);
        } else if (app.status === AppStatuses.DECLINED) {
          stats.declinedAppCount += 1;
        }
      });
      return map;
    },
  );

  const selBudgetPrograms = createSelector(
    [selProgramStats, selAllPrograms],
    (statsMap, programs) => {
      if (!programs) return null;
      return programs.filter(p => p.publishStatus !== Ps.DRAFT).map((program) => {
        const stats = statsMap[program.id] || statsMap.default;
        return {...program, stats};
      });
    }
  );

  const selProgramAdmins = createSelector(
    [selId, EntitiesSlx.grantPrograms, EntitiesSlx.employees],
    (programId, progMap, empMap) => {
      const prog = progMap[programId] || null;
      if (!prog?.adminIds) return null;
      return prog.adminIds.map(id => empMap[id]).filter(e => e);
    }
  );

  return {
    pathProgram: selPathProgram,
    pathProgramApps: selPathProgramApps,
    pathWorkflow: selPathWorkflow,
    pathApp: selPathApp,
    pathAppProgram: selPathAppProgram,
    pathAppWorkflow: selPathAppWorkflow,
    pathAppAssignments: selPathAppAssignments,
    pathAss: selPathAss,
    pathAssProgram: selPathAssProgram,
    pathAssApp: selPathAssApp,
    pathAssWorkflow: selPathAssWorkflow,

    appCommentMap: selAppCommentMap,
    appTimeline: selAppTimeline,
    appProgram: selAppProgram,
    appWorkflow: selAppWorkflow,
    appAssignments: selAppAssignments,


    bldrLandProg: selBldrLandProg,
    bldrAppProg: selBldrAppProg,
    allWorkflows: selAllWorkflows,
    templateWorkflows: selTemplateWorkflows,
    allPrograms: selAllPrograms,
    workflowCreatePending: selWorkflowCreatePending,
    taskUpdatePending: selTaskUpdatePending,
    assCompletePending: selAssCompletePending,
    myAssignments: selMyAssignments,
    myAssignmentsTodo: selMyAssignmentsTodo,
    myAssignmentsDone: selMyAssignmentsDone,
    cattrs: selCattrs,
    programStats: selProgramStats,
    budgetPrograms: selBudgetPrograms,
    allApps: selAllApps,
    appReassignPending: selAppReassignPending,
    allEmails: selAllEmails,
    poolTasks: selPoolTasks,
    appCounts: selAppCounts,
    wfUpdatePending: selWfUpdatePending,
    wfDeletePending: selWfDeletePending,
    programAdmins: selProgramAdmins,
    progUpdateAdminsPending: selProgUpdateAdminsPending,
  };

})();



export {Types, Ax, reducer, Slx};
export default {Types, Ax, reducer, Slx};
